import React from 'react'
import { Container, Button } from 'reactstrap'
import styled from 'styled-components'
// import backgroundImage from '../img/mr-stage.jpg'
import { Link } from 'gatsby'
import backgroundImage from '../img/bg_instituut.jpg'

const StyledHero = styled.div`
  background-image: url(${backgroundImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;
  position: relative;
  height: 400px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    align-items: center;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 250px;
  }
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(to bottom right, #fff 20%, rgba(0, 0, 0, 0));
    border-radius: inherit;
    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      background: linear-gradient(to bottom right, #fff 35%, rgba(0, 0, 0, 0));
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    h1 {
      font-size: 48px !important;
    }
    button {
      margin-top: 20px;
    }
  }
  h1,
  p,
  hr {
    position: relative;
    z-index: 10;
  }
`

function Hero() {
  return (
    <StyledHero className="jumbotron">
      <Container>
        <h1 className="display-4">SchoonheidsInstituut Isis</h1>
        <p className="lead">
          Een behandeling bij Instituut Isis is een belevenis die dieper gaat dan de huid!
        </p>
        {/* <div className="my-4" /> */}
        <p className="lead">
          <Link to="/contact">
            <Button size="xl" color="primary">
              Contacteer ons
            </Button>
          </Link>
        </p>
      </Container>
    </StyledHero>
  )
}

export default Hero
